<template>
  <div class="scheduled-respondent-form">
		<v-card class="card-create-respondents" outlined>
      <v-card-title><h1 class="h5 font-weight-regular">Create New Respondent Wizard</h1></v-card-title>
			<v-stepper
				v-model="e2"
				vertical
				ref="stepper"
			>
				<!-- STEP 1 -->
				<foe-stepper-step
					:complete="e2 > 1"
					:editable="e2 > 1"
					step="1"
					tabIndex="0"
					v-on:stepper-enter="handleStepperEnter"
					v-on:stepper-back="handleStepperBack"
					color="#B85623"
					class="respondentWizardStepper"
					role="button"
					aria-controls="steppercontent-1a"
					:aria-expanded="convertToString(openContent1)"
					v-on:click="clickStepHeader(1)"
				>
				<h2 v-if="e2===1" class="subtitle-1 font-weight-regular respondentWizardStepperHeaderOn" >Starting IDNumber: {{startingNum}} ({{selectedStudy.studyId}}{{startingNum}})</h2>
					<h2 v-else class="subtitle-1 font-weight-regular respondentWizardStepperHeaderOff">Starting IDNumber: {{startingNum}} ({{selectedStudy.studyId}}{{startingNum}})</h2>
				</foe-stepper-step>
				<v-stepper-content step="1" id="steppercontent-1a" :aria-disabled="!openContent1">
					<v-form
						ref="form1"
						v-model="valid"
						lazy-validation
						:class="{ 'd-block': openContent1, 'd-none': !openContent1}"
					>
						<v-row>
							<v-col
								:cols="2"
							>
								<p class="p2 left-align"><label for="form-starting-number">Identify the starting ID Number</label></p>
							</v-col>
							<v-col
								:cols="2"
							>
								<v-text-field
									v-model="startingNum"
									hide-details="auto"
									outlined
									id="form-starting-number"
									:rules="IDNumberRules"
									type="number"
									min="0"
									ref="firstFocusable"
								></v-text-field>
							</v-col>
							<v-col
								:cols="2"
							>
								{{selectedStudy.studyId}}{{startingNum}}
							</v-col>
							<v-col
								:cols="6"
							>
								<div class="sidebar-callout">
									<p class="p2 expl">Respondent usernames are comprised of the study abbreviation ({{selectedStudy.studyId}}) and an ID number.
										The wizard will use the starting ID number and create a range of unique usernames. You will specify the number of
										usernames to create in a subsequent step.
										<br><br>
										For example, if you specify 101, the first username will be {{selectedStudy.studyId}}101.
										<br><br>
										If you're not sure how to create a scheduled study with the wizard, start with a suggested scheduled study configuration. You can then customize the settings to suit your needs: <a href="SuggestedScheduledStudyConfigurations-FINAL.pdf" download>ASA24 Suggested Scheduled Study Configurations [pdf]</a>
									</p>
								</div>
							</v-col>
						</v-row>
						<v-divider inset></v-divider>
						<v-card-actions>
							<v-btn text class="btn-default" @click="onOpenCancel()">Cancel</v-btn>
							<v-spacer></v-spacer>
							<v-btn text class="btn-default" @click="onOpenCancel()">&lt; Back</v-btn>
							<v-btn
								:loading="loadingSave"
								text
								class="btn-default"
								@click="check(1)"
							>
								Next >
							</v-btn>
						</v-card-actions>
					</v-form>
				</v-stepper-content>
				<!-- STEP 2 -->
				<foe-stepper-step
					:complete="e2 > 2"
					:editable="e2 > 2"
					step="2"
					tabIndex="0"
					v-on:stepper-enter="handleStepperEnter"
					v-on:stepper-back="handleStepperBack"
					color="#B85623"
					class="respondentWizardStepper"
					role="button"
					aria-controls="steppercontent-2a"
					:aria-expanded="convertToString(openContent2)"
					v-on:click="clickStepHeader(2)"
				>
					<h2 v-if="e2===2" class="subtitle-1 font-weight-regular respondentWizardStepperHeaderOn" >Number of respondents to create: {{respondentNum}}</h2>
					<h2 v-else class="subtitle-1 font-weight-regular respondentWizardStepperHeaderOff">Number of respondents to create: {{respondentNum}}</h2>
				</foe-stepper-step>
				<v-stepper-content step="2" id="steppercontent-2a" :aria-disabled="!openContent2">
					<v-form
						ref="form2"
						v-model="valid"
						lazy-validation
						:class="{ 'd-block': openContent2, 'd-none': !openContent2}"
					>
						<v-row>
							<v-col
								:cols="2"
							>
								<p class="p2 left-align"><label for="form-respondent-number">Number of Respondents:</label></p>
							</v-col>
							<v-col
								:cols="2"
							>
								<v-text-field
									v-model="respondentNum"
									hide-details="auto"
									outlined
									id="form-respondent-number"
									:rules="IDNumberRules"
									type="number"
									min="0"
								></v-text-field>
							</v-col>
							<v-col
								:cols="2"
							>
							</v-col>
							<v-col
								:cols="6"
							>
								<div class="sidebar-callout">
									<p class="p2 expl">
										Specify the number of respondent usernames to be created.
										You can add more usernames later, as needed.
									</p>
								</div>
							</v-col>
						</v-row>
						<v-divider inset></v-divider>
						<v-card-actions>
							<v-btn text class="btn-default" @click="onOpenCancel()">Cancel</v-btn>
							<v-spacer></v-spacer>
							<v-btn text class="btn-default" @click="e2--">&lt; Back</v-btn>
							<v-btn
								text
								class="btn-default"
								@click="check(2)"
							>
								Next >
							</v-btn>
						</v-card-actions>
					</v-form>
				</v-stepper-content>
				<!-- STEP 3 -->
				<foe-stepper-step
					:complete="e2 > 3"
					:editable="e2 > 3"
					step="3"
					tabIndex="0"
					v-on:stepper-enter="handleStepperEnter"
					v-on:stepper-back="handleStepperBack"
					color="#B85623"
					class="respondentWizardStepper"
					role="button"
					aria-controls="steppercontent-3a"
					:aria-expanded="convertToString(openContent3)"
					v-on:click="clickStepHeader(3)"
				>
					<h2 v-if="e2===3" class="subtitle-1 font-weight-regular respondentWizardStepperHeaderOn" >Number of recalls per respondent: {{recallsRespondentNum}}</h2>
					<h2 v-else class="subtitle-1 font-weight-regular respondentWizardStepperHeaderOff">Number of recalls per respondent: {{recallsRespondentNum}}</h2>
				</foe-stepper-step>
				<v-stepper-content step="3" id="steppercontent-3a" :aria-disabled="!openContent3">
					<v-form
						ref="form3"
						v-model="valid"
						lazy-validation
						:class="{ 'd-block': openContent3, 'd-none': !openContent3}"
					>
						<v-row>
							<v-col
								:cols="2"
							>
								<p class="p2 left-align"><label for="form-recalls-number">Number of recalls per respondent</label></p>
							</v-col>
							<v-col
								:cols="2"
							>
								<v-text-field
									v-model="recallsRespondentNum"
									hide-details="auto"
									outlined
									id="form-recalls-number"
									:rules="recallsRespondentNumRules"
									:error="recallsRespondentNumHasError"
									:errorMessages="recallsRespondentNumError"
									type="number"
									min="0"
								></v-text-field>
							</v-col>
							<v-col
								:cols="2"
							>
							</v-col>
							<v-col
								:cols="6"
							>
								<div class="sidebar-callout">
									<p class="p2 expl">
										The default number of recalls to be completed by each respondent is the number you provided when you created the study.
										You can change the number of recalls per respondent here, if necessary. Note: In a later step, you will be asked to specify
										the number of attempts allowed for each recall.
									</p>
								</div>
							</v-col>
						</v-row>
						<v-divider inset></v-divider>
						<v-card-actions>
							<v-btn text class="btn-default" @click="onOpenCancel()">Cancel</v-btn>
							<v-spacer></v-spacer>
							<v-btn text class="btn-default" @click="e2--">&lt; Back</v-btn>
							<v-btn
								text
								class="btn-default"
								@click="check(3)"
							>
								Next >
							</v-btn>
						</v-card-actions>
					</v-form>
				</v-stepper-content>
				<!-- STEP 4 -->
				<foe-stepper-step
					:complete="e2 > 4"
					:editable="e2 > 4"
					step="4"
					tabIndex="0"
					v-on:stepper-enter="handleStepperEnter"
					v-on:stepper-back="handleStepperBack"
					color="#B85623"
					class="respondentWizardStepper"
					role="button"
					aria-controls="steppercontent-4a"
					:aria-expanded="convertToString(openContent4)"
					v-on:click="clickStepHeader(4)"
				>
					<h2 v-if="e2===4" class="subtitle-1 font-weight-regular respondentWizardStepperHeaderOn" >Distribution of Recalls: {{recallDistribution}}</h2>
					<h2 v-else class="subtitle-1 font-weight-regular respondentWizardStepperHeaderOff">Distribution of Recalls: {{recallDistribution}}</h2>
				</foe-stepper-step>
				<v-stepper-content step="4" id="steppercontent-4a" :aria-disabled="!openContent4">
					<v-form
						ref="form4"
						v-model="valid"
						lazy-validation
						:class="{ 'd-block': openContent4, 'd-none': !openContent4}"
					>
						<v-row>
							<v-col
								:cols="2"
							>
								<p class="p2 left-align">Distribution of Recalls</p>
							</v-col>
							<v-col
								:cols="4"
							>
								<v-radio-group
									v-model="recallDistribution"
									:rules="radioRules"
									id="form-distro-recalls"
								>
									<v-radio
										v-for="(distroRecall, i) in this.$respondentsWizardLists.distroRecalls"
										:key="distroRecall.value + i"
										:label="distroRecall.displayText"
										:value="distroRecall.value"
									></v-radio>
								</v-radio-group>
							</v-col>
							<v-col
								:cols="6"
							>
								<div class="sidebar-callout">
									<p class="p2 expl">
										Respondent recalls can be randomly distributed across all days of the week, including weekdays and weekend days.
										Alternatively, specify the number of recalls per respondent to be scheduled on weekend days (Friday, Saturday,
										and Sunday) and the remaining recalls will be randomly distributed on weekdays.
										<br><br>
										If the study includes only one recall per respondent, choose "Randomly distribute" to spread all recalls for the
										study across all days of the week. The <a href="https://dietassessmentprimer.cancer.gov/" target="_blank" aria-label="Dietary Assessment Primer - New Window">Dietary Assessment Primer</a>
										explains why this is important. Choose
										"Specify the number of weekend recalls" to schedule all recalls on weekend day
									</p>
								</div>
							</v-col>
						</v-row>
						<v-divider inset></v-divider>
						<v-card-actions>
							<v-btn text class="btn-default" @click="onOpenCancel()">Cancel</v-btn>
							<v-spacer></v-spacer>
							<v-btn text class="btn-default" @click="e2--">&lt; Back</v-btn>
							<v-btn
								text
								class="btn-default"
								@click="check(4)"
							>
								Next >
							</v-btn>
						</v-card-actions>
					</v-form>
				</v-stepper-content>
				<!-- STEP 4B -->
				<foe-stepper-step
					v-if="recallDistribution === $respondentsWizardLists.distroRecalls[1].value"
					:complete="e2 > 4"
					:editable="e2 > 4"
					step="4B"
					color="#B85623"
					class="respondentWizardStepper"
					:aria-expanded="convertToString(openContent4)"
					role="button"
					aria-controls="steppercontent-4ab"
				>
					<h2 v-if="e2===4" class="subtitle-1 font-weight-regular respondentWizardStepperHeaderOn" >Number of recalls per respondent on weekend days: {{recallsWeekendNum}}</h2>
					<h2 v-else class="subtitle-1 font-weight-regular respondentWizardStepperHeaderOff">Number of recalls per respondent on weekend days: {{recallsWeekendNum}}</h2>
				</foe-stepper-step>
				<v-stepper-content step="4B" id="steppercontent-4ab" :aria-disabled="!openContent4">
					<v-form
						ref="form4b"
						v-model="valid"
						lazy-validation
						:class="{ 'd-block': openContent4, 'd-none': !openContent4}"
					>
						<v-row>
							<v-col
								:cols="2"
							>
								<p class="p2 left-align"><label for="form-recalls-weekend-number">Number of recalls per respondent on weekend days:</label></p>
							</v-col>
							<v-col
								:cols="2"
							>
								<v-text-field
									v-model="recallsWeekendNum"
									hide-details="auto"
									outlined
									id="form-recalls-weekend-number"
									:rules="IDNumberRules"
									type="number"
									min="0"
								></v-text-field>
							</v-col>
							<v-col
								:cols="2"
							>
							</v-col>
							<v-col
								:cols="6"
							>
								<div class="sidebar-callout">
									<p class="p2 expl">
										Of the total number of recalls per respondent, specify the number to be scheduled on weekend days (Friday, Saturday, Sunday).
										<br><br>
										<ul>
											<li>For example, if your study includes 10 recalls per respondent and you would like 2 of the 10 recalls to be scheduled on weekend days, enter 2.</li>
											<li>If your study includes only one recall per respondent, indicate 1 in the box below to schedule all recalls for the study on weekend days.</li>
										</ul>
									</p>
								</div>
							</v-col>
						</v-row>
						<v-divider inset></v-divider>
						<v-card-actions>
							<v-btn text class="btn-default" @click="onOpenCancel()">Cancel</v-btn>
							<v-spacer></v-spacer>
							<v-btn text class="btn-default" @click="e2 = 4">&lt; Back</v-btn>
							<v-btn
								text
								class="btn-default"
								@click="check('4B')"
							>
								Next >
							</v-btn>
						</v-card-actions>
					</v-form>
				</v-stepper-content>
				<!-- STEP 5 -->
				<foe-stepper-step
					:complete="e2 > 5"
					:editable="e2 > 5"
					step="5"
					tabIndex="0"
					v-on:stepper-enter="handleStepperEnter"
					v-on:stepper-back="handleStepperBack"
					color="#B85623"
					class="respondentWizardStepper"
					role="button"
					aria-controls="steppercontent-5a"
					:aria-expanded="convertToString(openContent5)"
					v-on:click="clickStepHeader(5)"
				>
					<h2 v-if="e2===5" class="subtitle-1 font-weight-regular respondentWizardStepperHeaderOn" >	Number of days between recalls: {{daysBetweenValueFrom}}
						<span v-if="this.daysBetweenValueTo && daysBetween === this.$respondentsWizardLists.daysBetween[3].displayText"> to {{daysBetweenValueTo}}</span> days</h2>
					<h2 v-else class="subtitle-1 font-weight-regular respondentWizardStepperHeaderOff">	Number of days between recalls: {{daysBetweenValueFrom}}
						<span v-if="this.daysBetweenValueTo && daysBetween === this.$respondentsWizardLists.daysBetween[3].displayText"> to {{daysBetweenValueTo}}</span> days</h2>
				</foe-stepper-step>
				<v-stepper-content step="5" id="steppercontent-5a" :aria-disabled="!openContent5">
					<v-form
						ref="form5"
						v-model="valid"
						lazy-validation
						:class="{ 'd-block': openContent5, 'd-none': !openContent5}"
					>
						<v-row>
							<v-col
								:cols="6"
							>
								<v-row>
									<v-col
										:cols="4"
									>
										<p class="p2 left-align">Number of days between recalls:</p>
									</v-col>
									<v-col
										:cols="8"
									>
										<v-select
											:items="daysBetweenOptions"
											label="Select"
											outlined
											v-model="daysBetween"
											:rules="radioRules"
											id="form-days-between-recalls"
											:error="daysBetweenHasError"
											:errorMessages="daysBetweenError"
										></v-select>
									</v-col>
								</v-row>
								<v-row
									v-if="daysBetween === this.$respondentsWizardLists.daysBetween[3].displayText"
								>
									<v-col
										:cols="4"
									>
									</v-col>
									<v-col
										:cols="3"
									>
										<v-text-field
											v-model="rangeStart"
											hide-details="auto"
											outlined
											id="form-days-between-start"
											:rules="requiredRule"
											type="number"
											min="0"
										></v-text-field>
									</v-col>
									<v-col
										:cols="2"
									>
										<p class="p2">to</p>
									</v-col>
									<v-col
										:cols="3"
									>
										<v-text-field
											v-model="rangeEnd"
											hide-details="auto"
											outlined
											id="form-days-between-end"
											:rules="rangeEndRules"
											type="number"
											min="0"
											:disabled="rangeStart === ''"
										></v-text-field>
									</v-col>
								</v-row>
								<v-row
									v-if="daysBetween === this.$respondentsWizardLists.daysBetween[4].displayText"
								>
									<v-col
										:cols="4"
									>
									</v-col>
									<v-col
										:cols="4"
									>
										<p class="p2">Custom number:</p>
									</v-col>
									<v-col
										:cols="4"
									>
										<v-text-field
											v-model="customDays"
											hide-details="auto"
											outlined
											id="form-days-between-custom"
											:rules="requiredRule"
											type="number"
											min="0"
										></v-text-field>
									</v-col>
								</v-row>
							</v-col>
							<v-col
								:cols="6"
							>
								<div class="sidebar-callout">
									<p class="p2 expl">
										Select the number of days between recalls.
										<br><br>
										For example, for 30 days select monthly (30 days). If you want to enter a specific number
										of days, select Custom and enter your number in the box that appears.
									</p>
								</div>
							</v-col>
						</v-row>
						<v-divider inset></v-divider>
						<v-card-actions>
							<v-btn text class="btn-default" @click="onOpenCancel()">Cancel</v-btn>
							<v-spacer></v-spacer>
							<v-btn text class="btn-default" @click="e2--">&lt; Back</v-btn>
							<v-btn
								text
								class="btn-default"
								@click="check(5)"
							>
								Next >
							</v-btn>
						</v-card-actions>
					</v-form>
				</v-stepper-content>
				<!-- STEP 6 -->
				<foe-stepper-step
					:complete="e2 > 6"
					:editable="e2 > 6"
					step="6"
					tabIndex="0"
					v-on:stepper-enter="handleStepperEnter"
					v-on:stepper-back="handleStepperBack"
					color="#B85623"
					style="background-color: #42729B !important; padding: 8px 24px 3px"
					role="button"
					aria-controls="steppercontent-6a"
					:aria-expanded="convertToString(openContent6)"
					v-on:click="clickStepHeader(6)"
				>
					<h2 v-if="e2===6" class="subtitle-1 font-weight-regular respondentWizardStepperHeaderOn" >Number of attempts each respondent is allowed for each recall: {{attemptNum}}
						<br>
						Number of days between each attempt: {{daysAttemptBetweenFromNum}}
						<span v-if="daysBetweenAttemptChoice === this.$respondentsWizardLists.daysBetweenAttemptChoices[1].value"> to {{daysAttemptBetweenToNum}}</span></h2>
					<h2 v-else class="subtitle-1 font-weight-regular respondentWizardStepperHeaderOff">Number of attempts each respondent is allowed for each recall: {{attemptNum}}
						<br>
						Number of days between each attempt: {{daysAttemptBetweenFromNum}}
						<span v-if="daysBetweenAttemptChoice === this.$respondentsWizardLists.daysBetweenAttemptChoices[1].value"> to {{daysAttemptBetweenToNum}}</span></h2>
				</foe-stepper-step>
				<v-stepper-content step="6" id="steppercontent-6a" :aria-disabled="!openContent6">
					<v-form
						ref="form6"
						v-model="valid"
						lazy-validation
						:class="{ 'd-block': openContent6, 'd-none': !openContent6}"
					>
						<v-row>
							<v-col
								:cols="6"
							>
								<v-row>
									<v-col>
										<p class="p2 left-align">Attempts</p>
									</v-col>
								</v-row>
								<v-row>
									<v-col
										:cols="8"
									>
										<p class="p2 left-align">Number of attempts each respondent is allowed for each recall:</p>
									</v-col>
									<v-col
										:cols="4"
									>
										<v-text-field
											v-model="attemptNum"
											hide-details="auto"
											outlined
											id="form-recalls-attempts"
											:rules="IDNumberRules"
											:error="attemptNumHasError"
											:errorMessages="attemptNumError"
											type="number"
											min="0"
										></v-text-field>
									</v-col>
								</v-row>
								<v-row>
									<v-col
										:cols="6"
									>
										<p class="p2 left-align">Number of days between each attempt:</p>
									</v-col>
									<v-col
										:cols="6"
									>
										<v-radio-group
											v-model="daysBetweenAttemptChoice"
											:rules="radioRules"
											id="form-days-between-attempt-choices"
											:disabled="attemptNum === '1'"
										>
											<v-radio
												v-for="(attemptChoice, i) in this.$respondentsWizardLists.daysBetweenAttemptChoices"
												:key="attemptChoice.value + i"
												:label="attemptChoice.displayText"
												:value="attemptChoice.value"
											></v-radio>
										</v-radio-group>
									</v-col>
								</v-row>
								<v-row
									v-if="daysBetweenAttemptChoice === this.$respondentsWizardLists.daysBetweenAttemptChoices[0].value"
								>
									<v-col
										:cols="6"
									>
									</v-col>
									<v-col
										:cols="3"
									>
										<p class="p2 left-align">Specify:</p>
									</v-col>
									<v-col
										:cols="3"
									>
										<v-text-field
											v-model="daysAttemptBetweenFromNum"
											hide-details="auto"
											outlined
											id="form-days-between-attempt-from"
											:rules="requiredRule"
											type="number"
											min="0"
											:disabled="attemptNum === '1'"
										></v-text-field>
									</v-col>
								</v-row>
								<v-row
									v-if="daysBetweenAttemptChoice === this.$respondentsWizardLists.daysBetweenAttemptChoices[1].value"
								>
									<v-col
										:cols="6"
									>
									</v-col>
									<v-col
										:cols="2"
									>
										<v-text-field
											v-model="daysAttemptBetweenFromNum"
											hide-details="auto"
											outlined
											id="form-days-between-attempt-to"
											:rules="requiredRule"
											type="number"
											min="0"
										></v-text-field>
									</v-col>
									<v-col
										:cols="2"
									>
										to
									</v-col>
									<v-col
										:cols="2"
									>
										<v-text-field
											v-model="daysAttemptBetweenToNum"
											hide-details="auto"
											outlined
											id="form-days-between-attempt"
											:rules="daysAttemptBetweenToNumRules"
											type="number"
											min="0"
											:disabled="daysAttemptBetweenFromNum === ''"
										></v-text-field>
									</v-col>
								</v-row>
								<v-row>
										<v-col>
											<p class="p2 left-align">
												<v-icon color="#42729B">info</v-icon> Keep in mind:  Because you specified recalls on weekend days, the first attempts for these recalls
												will be scheduled on weekend days. However, subsequent attempts may not fall on weekend days, depending
												on the other settings specified (e.g., days between recalls and attempts).
											</p>
										</v-col>
								</v-row>
							</v-col>
							<v-col
								:cols="6"
							>
								<div class="sidebar-callout">
									<p class="p2 expl">
										Specify the number of attempts to allow for each recall. Because respondents may not complete recalls on their
										scheduled dates, it may be helpful to allow multiple chances or "attempts" to complete each recall on subsequent
										days. If multiple attempts are allowed, specify the number of days between attempts. The number of attempts must
										be reasonable considering the number of days
										between recalls (specified in the previous step).
										<br><br>
										Next, specify the number of days between attempts.  For example, if respondents are given 3 attempts
										to complete each recall and subsequent attempts after the initial scheduled dates are to occur every
										2 days, enter 3 in the first box and 2 in the second box.
										<br><br>
										Alternatively, you can specify a range of days between attempts so that your respondents do not predict
										the pattern and the recall remains unannounced (see Dietary Assessment Primer for more information about
										reactivity).  Select the “specify range of days between” and enter the range when the boxes appear, such
										as 2 to 5 days.  The system will generate dates for each attempt between 2 to 5 days.
									</p>
								</div>
							</v-col>
						</v-row>
						<v-divider inset></v-divider>
						<v-card-actions>
							<v-btn text class="btn-default" @click="onOpenCancel()">Cancel</v-btn>
							<v-spacer></v-spacer>
							<v-btn text class="btn-default" @click="e2--">&lt; Back</v-btn>
							<v-btn
								text
								class="btn-default"
								@click="check(6)"
							>
								Next >
							</v-btn>
						</v-card-actions>
					</v-form>
				</v-stepper-content>
				<!-- Step 7 -->
				<foe-stepper-step
					:complete="e2 > 7"
					:editable="e2 > 7"
					step="7"
					tabIndex="0"
					v-on:stepper-enter="handleStepperEnter"
					v-on:stepper-back="handleStepperBack"
					color="#B85623"
					style="background-color: #42729B !important; padding: 8px 24px 3px;"
					role="button"
					aria-controls="steppercontent-7a"
					:aria-expanded="convertToString(openContent7)"
					v-on:click="clickStepHeader(7)"
				>
					<h2 v-if="e2===7" class="subtitle-1 font-weight-regular respondentWizardStepperHeaderOn" >Stages:
						<br>
						<div v-for="(stageDate, i) in stageDates" :key="stageDate.startingDate + i.toString()">
							<span v-if="stageDate.endDate !== '0'">Stage {{i+1}}: </span>{{stageDate.startDate}}
							<span v-if="stageDate.endDate !== '0'"> to {{stageDate.endDate}}</span>
						</div>
						</h2>
					<h2 v-else class="subtitle-1 font-weight-regular respondentWizardStepperHeaderOff">Stages:
						<br>
						<div v-for="(stageDate, i) in stageDates" :key="stageDate.startingDate + i.toString()">
							<span v-if="stageDate.endDate !== '0'">Stage {{i+1}}: </span>{{stageDate.startDate}}
							<span v-if="stageDate.endDate !== '0'"> to {{stageDate.endDate}}</span>
						</div></h2>
				</foe-stepper-step>
				<v-stepper-content step="7" id="steppercontent-7a" :aria-disabled="!openContent7">
					<v-form
						ref="form7"
						v-model="valid"
						lazy-validation
						:class="{ 'd-block': openContent7, 'd-none': !openContent7}"
					>
						<v-row>
							<v-col
								:cols="6"
							>
								<v-row>
									<v-col
										:cols="4"
									>
										<p class="p2 left-align">Stages:</p>
									</v-col>
									<v-col
										:cols="8"
									>
										<v-radio-group
											v-model="stageOption"
											:rules="radioRules"
											id="form-stage-option"
										>
											<v-radio
												v-for="(stageOption, i) in this.$respondentsWizardLists.stagesOptions"
												:key="stageOption.value + i"
												:label="stageOption.displayText"
												:value="stageOption.value"
											></v-radio>
										</v-radio-group>
									</v-col>
								</v-row>
								<v-row
									v-if="stageOption === this.$respondentsWizardLists.stagesOptions[0].value"
								>
									<v-col>
										<v-menu  v-model="startDateMenu" :close-on-content-click="false" offset-y tile allow-overflow >
											<template v-slot:activator="{ on, attrs }">
												<v-text-field
													v-model="startDate"
													hide-details="auto"
													outlined
													:rules="startDateRules"
													type="date"
													id="form-start-date-respondent"
													:error="startDateHasError"
													:errorMessages="startDateError"
													v-bind="attrs"
													v-on="on"
													@keydown.tab='startDateMenu = false'
												>
												</v-text-field>
											</template>
											<v-date-picker v-model="startDate" color="#42729B" style="margin: 0px; float: left" @input="startDateMenu = false"></v-date-picker>
										</v-menu>
									</v-col>
								</v-row>
							</v-col>
							<v-col
								:cols="6"
							>
								<div class="sidebar-callout">
									<p class="p2 expl">
										Depending on the nature of the study, breaking the study population into smaller groups
										and spreading their recalls across "stages" may be useful for creating a more manageable
										workload (e.g., for contacting respondents and monitoring their progress).
										<br><br>
										For example, a study of 400 respondents can be broken into 4 stages, with 100 respondents
										scheduled to begin the study and complete their first recalls in the first week, and the 3
										remaining stages of 100 respondents each to begin the study in the following three weeks.
										In addition, a time period for each stage can be specified so that recalls for the
										respondents within a stage will be spread out across the specified dates.
									</p>
								</div>
							</v-col>
						</v-row>
						<v-simple-table
							v-if="stageOption === this.$respondentsWizardLists.stagesOptions[1].value"
						>
							<thead>
								<tr>
									<th>
										Stage
									</th>
									<th>
										Start Date
									</th>
									<th>
										End Date
									</th>
									<th>
										Actions
									</th>
								</tr>
							</thead>
							<tbody>
								<tr
									v-for="(stageDate, i) in stageDates"
									:key="stageDate.startDate + i"
								>
									<td>{{i+1}}</td>
									<td>{{stageDate.startDate}}</td>
									<td>{{stageDate.endDate}}</td>
									<td>
										<v-btn text class="btn-default" @click="editStage(i)">Edit</v-btn>
										<v-btn text class="btn-default" @click="deleteStage(i)">Delete</v-btn>
									</td>
								</tr>
								<tr>
									<td></td>
									<td>
										<v-menu class="dateMenu"  v-model="startStageDateMenu" :close-on-content-click="false" offset-y tile allow-overflow >
											<template v-slot:activator="{ on, attrs }">
											<v-text-field
												v-model="startStageDate"
												hide-details="auto"
												outlined
												:rules="startDateRules"
												type="date"
												id="form-stage-start-date"
												:error="startStageDateHasError"
												:errorMessages="startStageDateError"
												name="form-stage-start-date"
												v-bind="attrs"
												v-on="on"
												@keydown.tab='startStageDateMenu = false'
												>
											</v-text-field>
											</template>
											<v-date-picker v-model="startStageDate" color="#42729B" style="margin: 0px; float: left" @input="startStageDateMenu = false"></v-date-picker>
										</v-menu>
									</td>
									<td>
										<v-menu v-model="endStageDateMenu" :close-on-content-click="false" offset-y tile allow-overflow >
											<template v-slot:activator="{ on, attrs }">
												<v-text-field
												v-model="endStageDate"
												hide-details="auto"
												outlined
												:rules="endDateRules"
												type="date"
												id="form-stage-end-date"
												:disabled="startStageDate === ''"
												name="form-stage-end-date"
												v-bind="attrs"
												v-on="on"
												@keydown.tab='endStageDateMenu = false'
												>
												</v-text-field>
											</template>
											<v-date-picker v-model="endStageDate" color="#42729B" style="margin: 0px; float: left" @input="endStageDateMenu = false"></v-date-picker>
										</v-menu>
									</td>
									<td>
										<v-btn text class="btn-default" @click="addStage()">Add stage</v-btn>
									</td>
								</tr>
							</tbody>
						</v-simple-table>
						<v-divider inset></v-divider>
						<v-card-actions>
							<v-btn text class="btn-default" @click="onOpenCancel()">Cancel</v-btn>
							<v-spacer></v-spacer>
							<v-btn text class="btn-default" @click="e2--">&lt; Back</v-btn>
							<v-btn
								text
								class="btn-default"
								@click="check(7)"
							>
								Next >
							</v-btn>
						</v-card-actions>
					</v-form>
					<v-form
						ref="formDateEdit"
						v-model="valid"
						lazy-validation
					>
						<foe-dialog
							v-model="dateDialog"
							:dialogW="dateDialog"
							persistent
							max-width="600px"
							class="date-edit-dialog"
						>
							<v-card class="date-edit-card">
								<v-card-title>Edit Stage</v-card-title>
								<v-card-text>
									<v-container>
										<v-row>
											<v-col
												cols="6"
											>
												<v-menu  v-model="startDateEditMenu" :close-on-content-click="false" offset-y tile allow-overflow >
													<template v-slot:activator="{ on, attrs }">
														<v-text-field
														v-model="startDateEdit"
														label="Start Date"
														hide-details="auto"
														outlined
														:rules="startDateEditRules"
														type="date"
														:error="startDateEditHasError"
														:errorMessages="startDateEditError"
														v-bind="attrs"
														v-on="on"
														@keydown.tab='startDateEditMenu = false'
														>
														</v-text-field>
														</template>
														<v-date-picker v-model="startDateEdit" color="#42729B" style="margin: 0px; float: left" @input="startDateEditMenu = false"></v-date-picker>
												</v-menu>
											</v-col>
											<v-col
												cols="6"
											>
												<v-menu  v-model="endDateEditMenu" :close-on-content-click="false" offset-y tile allow-overflow >
													<template v-slot:activator="{ on, attrs }">
														<v-text-field
															v-model="endDateEdit"
															label="End Date"
              								hide-details="auto"
              								outlined
              								:rules="endDateEditRules"
              								type="date"
															:disabled="startDateEdit === ''"
															v-bind="attrs"
      												v-on="on"
															@keydown.tab='endDateEditMenu = false'
															>
														</v-text-field>
													</template>
													<v-date-picker v-model="endDateEdit" color="#42729B" style="margin: 0px; float: left" @input="endDateEditMenu = false"></v-date-picker>
												</v-menu>
											</v-col>
										</v-row>
									</v-container>
								</v-card-text>
								<v-card-actions>
									<v-spacer></v-spacer>
									<v-btn
										text
										@click="dateDialog = false"
									>
										Cancel
									</v-btn>
									<v-btn
										text
										@click="saveEditDate()"
									>
										Save
									</v-btn>
								</v-card-actions>
							</v-card>
						</foe-dialog>
					</v-form>
				</v-stepper-content>
				<!-- Step 8 -->
				<foe-stepper-step
					:complete="e2 > 8"
					:editable="e2 > 8"
					step="8"
					tabIndex="0"
					v-on:stepper-enter="handleStepperEnter"
					v-on:stepper-back="handleStepperBack"
					color="#B85623"
					class="respondentWizardStepper"
					role="button"
					aria-controls="steppercontent-8a"
					:aria-expanded="convertToString(openContent8)"
					v-on:click="clickStepHeader(8)"
				>
					<h2 v-if="e2===8" class="subtitle-1 font-weight-regular respondentWizardStepperHeaderOn" >Account Passwords</h2>
					<h2 v-else class="subtitle-1 font-weight-regular respondentWizardStepperHeaderOff">Account Passwords</h2>
				</foe-stepper-step>
				<v-stepper-content step="8" id="steppercontent-8a" :aria-disabled="!openContent8">
					<v-form
						ref="form8"
						v-model="valid"
						lazy-validation
						:class="{ 'd-block': openContent8, 'd-none': !openContent8}"
					>
						<v-row>
							<v-col
								:cols="6"
							>
								<v-row>
									<v-col
										:cols="4"
									>
										<p class="p2 left-align">Setting account passwords</p>
									</v-col>
									<v-col :cols="8">

										<fieldset class="border-0">
											<legend class="d-sr-only">
												Setting account passwords
											</legend>

											<v-radio-group v-model="passwordSelection"
																		 :rules="radioRules"
																		 id="form-password-option">
												<v-radio v-for="(passwordOption, i) in this.$respondentsWizardLists.passwordOptions"
																 :key="passwordOption.value + i"
																 :label="passwordOption.displayText"
																 :value="passwordOption.value"></v-radio>
											</v-radio-group>

										</fieldset>

									</v-col>
								</v-row>
								<v-row
									v-if="passwordSelection === this.$respondentsWizardLists.passwordOptions[0].value"
								>
									<v-col
										:cols="4"
									>
										<p class="p2 left-align"><label for="form-password-root">Root word:</label></p>
									</v-col>
									<v-col
										:cols="8"
									>
										<v-text-field
											v-model="passwordRoot"
											hide-details="auto"
											outlined
											id="form-password-root"
											:rules="passwordRootRules"
										></v-text-field>
									</v-col>
								</v-row>
							</v-col>
							<v-col
								:cols="6"
							>
								<div class="sidebar-callout">
									<p class="p2 expl">
										There are two  options for password creation. A root word (e.g., Pizzas) can
										be specified and the system will generate random extensions to create secure passwords
										(e.g., Pizzas&amp;556). This root word must contain only alphanumeric characters and must
										be between four and six characters in length.
										<br><br>
										Alternatively, the system can generate random secure passwords (e.g. blaCKhaWk421!).
									</p>
								</div>
							</v-col>
						</v-row>
						<v-divider inset></v-divider>
						<v-card-actions>
							<v-btn text class="btn-default" @click="onOpenCancel()">Cancel</v-btn>
							<v-spacer></v-spacer>
							<v-btn text class="btn-default" @click="e2--">&lt; Back</v-btn>
							<v-btn
								text
								class="btn-default"
								@click="check(8, true)"
								:loading="submitBtnLoading"
							>
								Create Respondents
							</v-btn>
						</v-card-actions>
					</v-form>
				</v-stepper-content>
			</v-stepper>
    </v-card>
	</div>
</template>

<script>
import { researcherApiService } from '@/services/researcherApiService';
import { utilityService } from '@/services/utilityService';
export default {
	name: 'ScheduledRespondentForm',
	props: {
	},
	data: () => ({
		loadingSave: false,
		submitBtnLoading: false,
		valid: true,
		e2: 1,
		startingNum: '',
		respondentNum: '',
		recallsRespondentNum: '',
		recallDistribution: '',
		recallsWeekendNum: '',
		daysBetween: '',
		rangeStart: '',
		rangeEnd: '',
		customDays: '',
		attemptNum: '',
		daysBetweenAttemptChoice: '',
		daysAttemptBetweenFromNum: '',
		daysAttemptBetweenToNum: '',
		stageOption: '',
		passwordSelection: '',
		passwordRoot: '',
		startDate: '',
		stageDates: [],
		startStageDate: '',
		endStageDate: '',
		startDateEdit: '',
		endDateEdit: '',
		dateEditPos: '',
		tomorrowDate: '',
		IDNumberRules: [
			v => v !== '' || 'This section is required',
			v => v > 0 || 'Must be greater than 0'
		],
		requiredRule: [
			v => v !== '' || 'This section is required'
		],
		radioRules: [v => v !== '' || 'This section is required'],
		passwordRootRules: [
			v => v !== '' || 'This section is required',
			v => (v && v.length > 3) || 'The password root must be between 4-6 characters',
			v => (v && v.length < 7) || 'The password root must be between 4-6 characters'
		],
		startDateRules: [
			v => v !== '' || 'Improper date or missing value(s)'
		],
		endDateRules: [
			v => v !== '' || 'Improper date or missing value(s)'
		],
		startDateEditRules: [
			v => v !== '' || 'Improper date or missing value(s)'
		],
		endDateEditRules: [
			v => v !== '' || 'Improper date or missing value(s)'
		],
		recallsRespondentNumRules: [
			v => v !== '' || 'This section is required',
			v => v > 0 || 'Must be greater than 0'
		],
		rangeEndRules: [
			v => v !== '' || 'This section is required',
			v => v > 0 || 'Must be greater than 0'
		],
		daysAttemptBetweenToNumRules: [
			v => v !== '' || 'This section is required',
			v => v > 0 || 'Must be greater than 0'
		],
		daysBetweenOptions: [],
		dateDialog: false,
		firstPossibleDate: null,
		recallsRespondentNumHasError: false,
		recallsRespondentNumError: [],
		daysBetweenHasError: false,
		daysBetweenError: [],
		attemptNumHasError: false,
		attemptNumError: [],
		startDateHasError: false,
		startDateError: [],
		startStageDateHasError: false,
		startStageDateError: [],
		startDateEditHasError: false,
		startDateEditError: [],
		startDateMenu: false,
		startStageDateMenu: false,
		endStageDateMenu: false,
		startDateEditMenu: false,
		endDateEditMenu: false,
		openContent1: true,
		openContent2: false,
		openContent3: false,
		openContent4: false,
		openContent5: false,
		openContent6: false,
		openContent7: false,
		openContent8: false
	}),
	mounted () {
		const me = this;
		this.$respondentsWizardLists.daysBetween.forEach(option => me.daysBetweenOptions.push(option.displayText))
		var date = new Date();
		date.setDate(date.getDate() + 1);
		var month = '';
		var day = '';

		if ((date.getMonth() + 1) < 10) {
			month = '0' + (date.getMonth() + 1);
		} else {
			month = date.getMonth() + 1
		}

		if (date.getDate() < 10) {
			day = '0' + date.getDate();
		} else {
			day = date.getDate();
		}

		this.tomorrowDate = date.getFullYear() + '-' + month + '-' + day;
		this.firstPossibleDate = this.selectedStudy.dateStart > this.tomorrowDate ? this.selectedStudy.dateStart : this.tomorrowDate

		this.recallsRespondentNum = this.selectedStudy.numRecallsPerParticipant;

		this.$nextTick(function () {
			var vRadioGroup = document.getElementsByClassName('v-input--radio-group__input');
			for (var i = 0; i < vRadioGroup.length; i++) {
				vRadioGroup[i].removeAttribute('aria-labelledby');
			}
		});
		var myFirstElement = this.$refs.firstFocusable
		myFirstElement.focus();
	},
	watch: {
		stageOption: function (newVal, oldVal) {
			if (newVal) {
				this.stageDates = [];
				this.startDate = '';
				this.startStageDate = '';
				this.endStageDate = '';
			}
		},
		attemptNum: function (newVal, oldVal) {
			if (newVal === '1') {
				this.daysBetweenAttemptChoice = this.$respondentsWizardLists.daysBetweenAttemptChoices[0].value;
				this.daysAttemptBetweenFromNum = 0;
				if (this.attemptNumHasError) {
					this.attemptNumError.splice(this.attemptNumError.indexOf('The number of days needed to accommodate the number of attempts and days between attempts exceeds the specified number of days between recalls. To address this error, reduce the number of attempts or the days between attempts or increase the number of days between recalls.'), 1);
				}
			}

			var daysBetween = this.daysBetween === this.$respondentsWizardLists.daysBetween[3].displayText ? this.daysBetweenValueFrom : this.daysBetweenValueTo;

			if (newVal !== '' && (newVal - 1) > daysBetween) {
				this.attemptNumHasError = true;
				if (this.attemptNumError.indexOf('Number of attempts exceeds number of days between recalls') === -1) {
					this.attemptNumError.push('Number of attempts exceeds number of days between recalls');
				}
			} else if (oldVal !== '' && this.attemptNumHasError) {
				this.attemptNumError.splice(this.attemptNumError.indexOf('Number of attempts exceeds number of days between recalls'), 1);
			}

			if (!this.attemptNumError.length) {
				this.attemptNumHasError = false;
			}
		},
		recallsRespondentNum: function (newVal, oldVal) {
			if ((newVal || oldVal) && this.e2 === 3) {
				var compareDate = new Date(this.firstPossibleDate);
				compareDate.setDate(compareDate.getDate() + parseInt(newVal));
				var maxDate = new Date(this.selectedStudy.dateEnd);

				if (compareDate > maxDate) {
					this.recallsRespondentNumHasError = true;
					this.recallsRespondentNumError = ['Number of recalls go past the study end date'];
				} else if (this.recallsRespondentNumHasError) {
					this.recallsRespondentNumHasError = false;
					this.recallsRespondentNumError.pop();
				}
			}
		},
		e2: function (newVal) {
			if (!this.recallsRespondentNum && this.e2 === 3) {
				this.recallsRespondentNum = this.selectedStudy.numRecallsPerParticipant;
			}
			if (newVal === 1) {
				this.openContent1 = true
				this.openContent2 = false
				this.openContent3 = false
				this.openContent4 = false
				this.openContent5 = false
				this.openContent6 = false
				this.openContent7 = false
				this.openContent8 = false
			}
			if (newVal === 2) {
				this.openContent1 = false
				this.openContent2 = true
				this.openContent3 = false
				this.openContent4 = false
				this.openContent5 = false
				this.openContent6 = false
				this.openContent7 = false
				this.openContent8 = false
			}
			if (newVal === 3) {
				this.openContent1 = false
				this.openContent2 = false
				this.openContent3 = true
				this.openContent4 = false
				this.openContent5 = false
				this.openContent6 = false
				this.openContent7 = false
				this.openContent8 = false
			}
			if (newVal === 4) {
				this.openContent1 = false
				this.openContent2 = false
				this.openContent3 = false
				this.openContent4 = true
				this.openContent5 = false
				this.openContent6 = false
				this.openContent7 = false
				this.openContent8 = false
			}
			if (newVal === 5) {
				this.openContent1 = false
				this.openContent2 = false
				this.openContent3 = false
				this.openContent4 = false
				this.openContent5 = true
				this.openContent6 = false
				this.openContent7 = false
				this.openContent8 = false
			}
			if (newVal === 6) {
				this.openContent1 = false
				this.openContent2 = false
				this.openContent3 = false
				this.openContent4 = false
				this.openContent5 = false
				this.openContent6 = true
				this.openContent7 = false
				this.openContent8 = false
			}
			if (newVal === 7) {
				this.openContent1 = false
				this.openContent2 = false
				this.openContent3 = false
				this.openContent4 = false
				this.openContent5 = false
				this.openContent6 = false
				this.openContent7 = true
				this.openContent8 = false
			}
			if (newVal === 8) {
				this.openContent1 = false
				this.openContent2 = false
				this.openContent3 = false
				this.openContent4 = false
				this.openContent5 = false
				this.openContent6 = false
				this.openContent7 = false
				this.openContent8 = true
			}
		},
		recallDistribution: function (newVal) {
			if (newVal === 'random') {
				this.recallsWeekendNum = '';
				this.$refs.form4b.resetValidation();
			}
		},
		daysAttemptBetweenFromNum: function (newVal, oldVal) {
			if (newVal && this.daysBetweenAttemptChoice === this.$respondentsWizardLists.daysBetweenAttemptChoices[0].value) {
				this.checkNumberOfDaysBetweenAttempt(newVal, oldVal);
			}

			// Validation on daysAttemptBetweenToNum does not update if this variable changes state
			// this forces a validation when both inputs have a value
			if (newVal && this.daysAttemptBetweenToNum) {
				this.$refs.form6.validate();
			}
		},
		daysAttemptBetweenToNum: function (newVal, oldVal) {
			if (newVal && this.daysBetweenAttemptChoice === this.$respondentsWizardLists.daysBetweenAttemptChoices[1].value) {
				this.checkNumberOfDaysBetweenAttempt(newVal, oldVal);
			}
		},
		startDate: function (newVal) {
			if (newVal) {
				var compareDate = new Date(newVal);
				compareDate.setDate(compareDate.getDate() + ((parseInt(this.daysBetweenValueTo) + 1) * parseInt(this.recallsRespondentNum)));
				// compareDate is a different date format when compared to this.selectedStudy.dateEnd,
				// this makes them have the same format
				var maxDate = new Date(this.selectedStudy.dateEnd);

				if (compareDate > maxDate) {
					this.startDateHasError = true;
					this.startDateError = ['Selected date would schedule recalls after study end date'];
				} else if (this.startDateHasError) {
					this.startDateHasError = false;
					this.startDateError.pop();
				}
			}
		},
		startStageDate: function (newVal) {
			if (newVal) {
				var compareDate = new Date(newVal);
				compareDate.setDate(compareDate.getDate() + ((parseInt(this.daysBetweenValueTo) + 1) * parseInt(this.recallsRespondentNum)));
				// compareDate is a different date format when compared to this.selectedStudy.dateEnd,
				// this makes them have the same format
				var maxDate = new Date(this.selectedStudy.dateEnd);

				if (compareDate > maxDate) {
					this.startStageDateHasError = true;
					this.startStageDateError = ['Selected date would schedule recalls after study end date'];
				} else if (this.startStageDateHasError) {
					this.startStageDateHasError = false;
					this.startStageDateError.pop();
				}
			}
		},
		startDateEdit: function (newVal) {
			if (newVal) {
				var compareDate = new Date(newVal);
				compareDate.setDate(compareDate.getDate() + ((parseInt(this.daysBetweenValueTo) + 1) * parseInt(this.recallsRespondentNum)));
				// compareDate is a different date format when compared to this.selectedStudy.dateEnd,
				// this makes them have the same format
				var maxDate = new Date(this.selectedStudy.dateEnd);

				if (compareDate > maxDate) {
					this.startDateEditHasError = true;
					this.startDateEditError = ['Selected date would schedule recalls after study end date'];
				} else if (this.startDateEditHasError) {
					this.startDateEditHasError = false;
					this.startDateEditError.pop();
				}
			}
		},
		daysBetweenAttemptChoice: function (newVal) {
			if (newVal) {
				// This variable is populated automatically when the number of attempts is 1,
				// the selection for this watch variable might change too, this makes sure it doesn't
				// overwrite that change
				if (this.attemptNum !== '1') {
					this.daysAttemptBetweenFromNum = '';
				}

				this.daysAttemptBetweenToNum = '';
				this.attemptNumHasError = false;
				this.attemptNumError = [];
			}
		}
	},
	methods: {
		onOpenCancel () {
			this.$emit('cancel');
		},
		check (formNumber, lastStep = false) {
			if (this.startDateRules.length === 1) {
				// Locally defined dates use the string date format native to Vuetify components
				// Using the selectedStudy from the store the dates are stored as epoch milliseconds so convert to Date objects for rule comparison
				this.startDateRules.push(v => v >= this.tomorrowDate || 'Date must be greater than or equal to tomorrow');
				this.endDateRules.push(v => v > this.startStageDate || 'Date must be greater than the start date');
				this.startDateRules.push(v => new Date(v) >= new Date(this.selectedStudy.dateStart) || `Date must be greater than or equal to the study start date (${utilityService.formatDate(this.selectedStudy.dateStart)}`);
				this.startDateRules.push(v => new Date(v) <= new Date(this.selectedStudy.dateEnd) || `Date must be less than or equal to the study end date (${utilityService.formatDate(this.selectedStudy.dateEnd)}`);
				this.endDateRules.push(v => new Date(v) <= new Date(this.selectedStudy.dateEnd) || `Date must be less than or equal to the study end date (${utilityService.formatDate(this.selectedStudy.dateEnd)}`);

				this.startDateEditRules.push(v => v >= this.tomorrowDate || 'Date must be greater than or equal to tomorrow');
				this.endDateEditRules.push(v => v > this.startDateEdit || 'Date must be greater than the start date');
				this.startDateEditRules.push(v => new Date(v) >= new Date(this.selectedStudy.dateStart) || `Date must be greater than or equal to the study start date (${utilityService.formatDate(this.selectedStudy.dateStart)}`);
				this.startDateEditRules.push(v => new Date(v) <= new Date(this.selectedStudy.dateEnd) || `Date must be less than or equal to the study end date (${utilityService.formatDate(this.selectedStudy.dateEnd)}`);
				this.endDateEditRules.push(v => new Date(v) <= new Date(this.selectedStudy.dateEnd) || `Date must be less than or equal to the study end date (${utilityService.formatDate(this.selectedStudy.dateEnd)}`);

				this.rangeEndRules.push(v => v > this.rangeStart || 'Must be greater than first number');
				this.daysAttemptBetweenToNumRules.push(v => v > this.daysAttemptBetweenFromNum || 'Must be greater than first number')
			}

			var valid = false;
			switch (formNumber) {
			case 1:
				valid = this.$refs.form1.validate();
				break;
			case 2:
				valid = this.$refs.form2.validate();
				break;
			case 3:
				if (!this.recallsRespondentNumHasError) {
					valid = this.$refs.form3.validate();
				}
				break;
			case 4:
				valid = this.$refs.form4.validate();
				if (valid && this.recallDistribution === this.$respondentsWizardLists.distroRecalls[1].value) {
					this.e2 = '4B';
					return;
				}
				break;
			case '4B':
				valid = this.$refs.form4b.validate();
				if (valid) {
					this.e2 = 5;
					return;
				}
				break;
			case 5:
				if (!this.daysBetweenHasError) {
					valid = this.$refs.form5.validate();
				}
				break;
			case 6:
				if (!this.attemptNumHasError) {
					valid = this.$refs.form6.validate();
				}
				break;
			case 7:
				if (this.stageDates.length && this.stageOption === this.$respondentsWizardLists.stagesOptions[1].value) {
					valid = true;
				} else if (this.stageOption === this.$respondentsWizardLists.stagesOptions[0].value) {
					valid = this.$refs.form7.validate();
				}

				if (valid && this.stageOption === this.$respondentsWizardLists.stagesOptions[0].value) {
					this.stageDates = [];
					this.stageDates.push({ startDate: this.startDate, endDate: utilityService.formatDate(this.selectedStudy.dateEnd) });
				}
				break;
			case 8:
				valid = this.$refs.form8.validate();
				break;
			}

			if (valid && lastStep) {
				this.createRespondents();
			} else if (valid) {
				this.e2++;
			}
		},
		createRespondents () {
			this.submitBtnLoading = true;
			const me = this;
			researcherApiService.wizardCreateRespondents(this.selectedStudy.studyUuid, this.respondentsInfo)
				.then(function (response) {
					if (response) {
						me.$router.push({
							name: 'ConfirmationPage',
							params: {
								fileNameRespondents: response.data.fileNameRespondents,
								fileNameSchedule: response.data.fileNameSchedule
							}
						});
					}
					me.submitBtnLoading = false;
				})
				.catch(function (e) {
					console.log(e);
					me.submitBtnLoading = false;
				});
		},
		addStage () {
			var valid = this.$refs.form7.validate();

			if (valid) {
				this.stageDates.push({ startDate: this.startStageDate, endDate: this.endStageDate });
				this.startStageDate = '';
				this.endStageDate = '';
				this.$refs.form7.resetValidation();
			}
		},
		deleteStage (pos) {
			this.stageDates.splice(pos, 1);
		},
		editStage (pos) {
			this.startDateEdit = this.stageDates[pos].startDate;
			this.endDateEdit = this.stageDates[pos].endDate;
			this.dateEditPos = pos;
			this.dateDialog = true;
		},
		saveEditDate () {
			var valid = this.$refs.formDateEdit.validate();

			if (valid) {
				this.stageDates[this.dateEditPos].startDate = this.startDateEdit;
				this.stageDates[this.dateEditPos].endDate = this.endDateEdit;
				this.dateDialog = false;
			}
		},
		checkNumberOfDaysBetweenAttempt (newVal, oldVal) {
			var daysBetween = this.daysBetween === this.$respondentsWizardLists.daysBetween[3].displayText ? this.daysBetweenValueFrom : this.daysBetweenValueTo;
			if ((parseInt(this.attemptNum) * parseInt(newVal)) > parseInt(daysBetween)) {
				this.attemptNumHasError = true;
				if (this.attemptNumError.indexOf('The number of days needed to accommodate the number of attempts and days between attempts exceeds the specified number of days between recalls. To address this error, reduce the number of attempts or the days between attempts or increase the number of days between recalls.') === -1) {
					this.attemptNumError.push('The number of days needed to accommodate the number of attempts and days between attempts exceeds the specified number of days between recalls. To address this error, reduce the number of attempts or the days between attempts or increase the number of days between recalls.');
				}
			} else if (oldVal && this.attemptNumHasError) {
				this.attemptNumError.splice(this.attemptNumError.indexOf('The number of days needed to accommodate the number of attempts and days between attempts exceeds the specified number of days between recalls. To address this error, reduce the number of attempts or the days between attempts or increase the number of days between recalls.'), 1);
			}

			if (!this.attemptNumError.length) {
				this.attemptNumHasError = false;
			}
		},
		handleStepperEnter (args) {
			// Incoming args hold the stepper number. Update the binding variable with the value.
			// Only support this for going backwards. To move forwards the user must use the Next button.
			if (parseInt(args) < parseInt(this.e2)) {
				this.e2 = parseInt(args);
			}
		},
		/**
		 * Handles the stepper back tab event by changing the focus to the previous step header.
		 */
		handleStepperBack (args) {
			const isStepNotFirst = args.step > 1;
			// If we are moving back to the active step then tab through all controls in the step.
			const isNotMovingToActiveStep = (args.step - 1) !== parseInt(this.e2);
			if (isStepNotFirst && isNotMovingToActiveStep) {
				// If we are back tabbing to inactive steps, we need to set the focus to the previous step header.
				args.keyDownEvent.preventDefault();
				const steps = this.getStepperSteps();
				if (steps.length >= args.step) {
					steps[args.step - 2].$el.focus();
				}
			}
		},
		/**
		 * Gets all the StepperStepWrapper components that are children of the stepper ref.
		 */
		getStepperSteps () {
			return this.$refs.stepper.$children.filter(child => { return child.$options.name === 'StepperStepWrapper'; });
		},
		clickStepHeader (sNum) {
			if (parseInt(sNum) < parseInt(this.e2)) {
				this.e2 = parseInt(sNum);
			}
		},
		convertToString (text) {
			var stringText = text + ''
			return stringText
		}
	},
	computed: {
		selectedStudy: function () {
			// This computed property will update the study when the selected study is
			// modified in the store
			return this.$store.getters.getSelectedStudy;
		},
		daysBetweenValueFrom: function () {
			var value = null;

			if (this.daysBetween !== '') {
				for (var i = 0; i < this.$respondentsWizardLists.daysBetween.length; i++) {
					if (this.daysBetween === this.$respondentsWizardLists.daysBetween[i].displayText) {
						value = this.$respondentsWizardLists.daysBetween[i].value;

						if (value === this.$respondentsWizardLists.daysBetween[3].value) {
							value = this.rangeStart;
						} else if (value === this.$respondentsWizardLists.daysBetween[4].value) {
							value = this.customDays;
						}
					}
				}
			}

			// validation on rangeEnd does not update if this variable changes state
			// this forces a validation when both inputs have a value
			if (value && this.rangeEnd) {
				this.$refs.form5.validate();
			}

			return value;
		},
		daysBetweenValueTo: function () {
			var value = null;

			if (this.daysBetween !== '') {
				for (var i = 0; i < this.$respondentsWizardLists.daysBetween.length; i++) {
					if (this.daysBetween === this.$respondentsWizardLists.daysBetween[i].displayText) {
						value = this.$respondentsWizardLists.daysBetween[i].value;

						if (value === this.$respondentsWizardLists.daysBetween[3].value) {
							value = this.rangeEnd;
						} else if (value === this.$respondentsWizardLists.daysBetween[4].value) {
							value = this.customDays;
						}
					}
				}
			}

			if (value) {
				var compareDate = new Date(this.firstPossibleDate);
				compareDate.setDate(compareDate.getDate() + ((parseInt(value) + 1) * parseInt(this.recallsRespondentNum)));
				// compareDate is a different date format when compared to this.selectedStudy.dateEnd,
				// this makes them have the same format
				var maxDate = new Date(this.selectedStudy.dateEnd);

				if (compareDate > maxDate) {
					/* eslint-disable vue/no-side-effects-in-computed-properties */
					this.daysBetweenHasError = true;
					this.daysBetweenError = ['Days between recalls with current number of recalls go past the study end date'];
				} else if (this.daysBetweenHasError) {
					this.daysBetweenHasError = false;
					this.daysBetweenError.pop();
				}
			}

			return value;
		},
		respondentsInfo: function () {
			var stages = this.stageDates;
			for (var i = 0; i < stages.length; i++) {
				stages[i].stageNumber = (i + 1);
			}

			var info = {
				startingIdNumber: this.startingNum,
				respondentCount: this.respondentNum,
				recallsPerRespondent: this.recallsRespondentNum,
				randomDistribution: this.recallDistribution === this.$respondentsWizardLists.distroRecalls[0].value,
				recallsWeekendCount: this.recallsWeekendNum !== '' ? this.recallsWeekendNum : '0',
				numDaysBetweenRecallFrom: this.daysBetweenValueFrom,
				numDaysBetweenRecallTo: this.daysBetweenValueTo,
				numAttempts: this.attemptNum,
				daysBetweenAttemptsFrom: this.daysAttemptBetweenFromNum,
				daysBetweenAttemptsTo: this.daysBetweenAttemptChoice === this.$respondentsWizardLists.daysBetweenAttemptChoices[1].value ? this.daysAttemptBetweenToNum : this.daysAttemptBetweenFromNum,
				stages: stages,
				hasPasswordRoot: this.passwordSelection === this.$respondentsWizardLists.passwordOptions[0].value,
				passwordRoot: this.passwordRoot,
				studyUuid: this.selectedStudy.studyUuid,
				wizardType: this.$respondentsWizardLists.WIZARD_TYPE_SCHEDULED.value
			}
			return info;
		}
	}
}
</script>

<style>
</style>
